import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ArticlePage } from './pages/ArticlePage';
import { Home } from './pages/Home';
import { NewsPage } from './pages/NewsPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k92om18wo2mb">
      <Routes data-id="element-1" data-mp="3k7i5d7s1k63r">
        <Route path="/" element={<Home data-id="element-3" data-mp="3f9yi5idd8izo" />} data-id="element-2" data-mp="3k78bva7sfgtb" />
        <Route path="/news" element={<NewsPage data-id="element-5" data-mp="3fb9if87lr8m1" />} data-id="element-4" data-mp="3fbjdha7i85yl" />
        <Route path="/news/:slug" element={<ArticlePage data-id="element-7" data-mp="2rk46h44s90h0" />} data-id="element-6" data-mp="3f8n9p58z6n28" />
      </Routes>
    </BrowserRouter>;
}